import { hasPlatformRole, type PlatformRole } from "@rivaled/shared";

import { useSession } from "../lib/auth-client";

/**
 * Read the current user's platform role from the BetterAuth session.
 */
export function usePlatformRole() {
  const { data: session, isPending } = useSession();

  const role = (session?.user?.role as PlatformRole | undefined) ?? null;

  return {
    role,
    isLoading: isPending,
    isStaff: role !== null,
    isAdmin: hasPlatformRole(role, "admin"),
    isModerator: hasPlatformRole(role, "moderator"),
    isDeveloper: hasPlatformRole(role, "developer"),
  };
}
